// F-3 — safeReturnTo validator. The LoginPage and SignupPage must
// only navigate to paths that match `^/app(/|$)` with no double slash,
// no backslash, and no scheme. Anything else falls back to
// `/app/workout`. Returning a string from `navigate(...)` that
// begins with `//` or contains a scheme can be misused as an open
// redirect in future code.

const FALLBACK = "/app/workout";

export function safeReturnTo(raw: string | null | undefined): string {
  if (!raw) return FALLBACK;
  let value: string;
  try {
    value = decodeURIComponent(raw);
  } catch {
    return FALLBACK;
  }
  // Reject anything that is not a same-origin path under /app.
  if (!value.startsWith("/app")) return FALLBACK;
  if (value.startsWith("//")) return FALLBACK;
  if (value.includes("\\")) return FALLBACK;
  if (value.includes("://")) return FALLBACK;
  // Must not contain a scheme prefix.
  if (/^[a-z]+:/i.test(value)) return FALLBACK;
  // Path traversal: the segment ".." should not appear.
  if (value.split("/").includes("..")) return FALLBACK;
  return value;
}
